import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateDoctorClinicDto, CreateDoctorDto } from "../../api-client";
import { useApi } from "../../api/ApiProvider";
import { doctorKeys } from "./doctor.keys";
import notificationStore from "../Notification/notificationStore";

/**
 * Hook for removing a doctor
 * Replaces DoctorStore.removeDoctor
 */
export const useRemoveDoctor = () => {
  const { doctors } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (doctorId: string) => {
      return await doctors.doctorControllerRemoveDoctor(doctorId);
    },
    onSuccess: (_data, doctorId) => {
      notificationStore.showMessage(`Arzt erfolgreich entfernt`, "success");
      queryClient.invalidateQueries({ queryKey: ["doctorClinics"] });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message || "Fehler beim Entfernen des Arztes",
        "error",
        error
      );
    },
  });
};

/**
 * Hook for updating a doctor
 * Replaces DoctorStore.handleUpdateDoctor
 */
export const useUpdateDoctor = () => {
  const { doctors } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, dto }: { id: string; dto: CreateDoctorDto }) => {
      return await doctors.doctorControllerUpdateDoctor(id, dto);
    },
    onSuccess: (_data, variables) => {
      notificationStore.showMessage(`Arzt erfolgreich aktualisiert`, "success");
      queryClient.invalidateQueries({ queryKey: ["doctorClinics"] });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message || "Fehler beim Aktualisieren des Arztes",
        "error",
        error
      );
    },
  });
};

/**
 * Hook for creating a doctor with clinic
 * Replaces DoctorStore.createDoctorWithClinic
 */
export const useCreateDoctorWithClinic = () => {
  const { doctors } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: CreateDoctorClinicDto) => {
    return await doctors.doctorControllerCreateDoctorWithClinic(dto);
    },
    onSuccess: () => {
      notificationStore.showMessage(
        "Arzt erfolgreich mit Klinik erstellt",
        "success"
      );
      queryClient.invalidateQueries({ queryKey: ["doctorClinics"] });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message ||
          "Fehler beim Erstellen des Arztes mit Klinik",
        "error",
        error
      );
    },
  });
};